import React, { useState, useEffect } from 'react';
import './Loading.css';

const Loading = () => {
  // public 폴더에 있는 GIF 파일 경로
  const loadingGifFile = '/loading.gif';

  // GIF 이미지의 src를 관리하는 상태. 브라우저 캐시 문제를 해결하기 위함입니다.
  const [imageSrc, setImageSrc] = useState('');

  // 컴포넌트가 화면에 표시될 때마다 GIF를 처음부터 재생하도록 합니다.
  useEffect(() => {
    // 이미지 경로 뒤에 현재 시간을 덧붙여 매번 새로운 URL인 것처럼 만듭니다.
    setImageSrc(`${loadingGifFile}?${new Date().getTime()}`);
  }, []); // []를 비워두어 컴포넌트가 처음 나타날 때 한 번만 실행되도록 합니다.

  return (
    <div className="loading-overlay">
      <div className="loading-content">
        {/* state에 저장된 이미지 경로를 사용합니다. */}
        <img src={imageSrc} alt="로딩 중..." className="loading-media" />
        
        <p className="loading-text">잠시만 기다려주세요...</p>
      </div>
    </div>
  );
};

export default Loading;